import React from 'react';
import { useRoutes } from 'react-router-dom';
import mainRoutes from './mainRoutes'; // adjust path if needed
import companyRoutes from './companyRoutes';
import branchRoutes from './branchRoutes';
import authRoutes from './AuthRoutes';

const AppRoutes = () => {
  const routes = useRoutes([
    mainRoutes,
    companyRoutes,
    branchRoutes,
    authRoutes
    // You can also add other layouts or standalone routes here if needed
  ]);

  return routes;
};

export default AppRoutes;
